module.exports = __webpack_public_path__ + "assets/e8e5f1c5f07c2407735c165e6537355a.png";